export default __webpack_public_path__ + "static/computer-and-ellipsis-6d8618dc7337af8d881f409413913f7c.png";